;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { type ReactNode } from 'react'

import { Logo } from './logo'

/**
 * The centred "there is nothing here yet" block: logomark, heading, a line of
 * explanation, and the actions that get the user out of the state.
 *
 * `actions` is where the way out goes — usually one `Anchor` or `Button`, or a
 * fragment of two. Pass the buttons themselves; the spacing between them and
 * the heading is the component's job.
 */
export function EmptyState({
  header,
  description,
  actions,
}: {
  header: string
  description: ReactNode
  actions?: ReactNode
}) {
  return (
    <div className="flex flex-col items-center text-center">
      <div className="flex flex-col items-center gap-3 text-center">
        <Logo name="qogita-logomark" className="h-12 w-12" />
        <h2 className="typography-header-4xl-bold">{header}</h2>
        <p className="text-low-emphasis max-w-prose text-balance">
          {description}
        </p>
      </div>
      {actions ? (
        <div className="mt-8 flex flex-col flex-wrap gap-4 md:flex-row">
          {actions}
        </div>
      ) : null}
    </div>
  )
}
